// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3_BnW","inputWrap":"CustomTip_inputWrap__2vA-q"};